import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { UntypedFormArray, ReactiveFormsModule } from '@angular/forms';
import {WaConversionsEvent, WaSettings} from './wa-settings-form';
import {Step} from '../../../../../../../shared/models';
import isEmpty from 'lodash/isEmpty';
import {SendTemplateService, WaBusinessAccounts} from '../../actions/send-template/send-template.service';
import {tap} from 'rxjs/operators';
import {swalMini} from '../../../../../../../shared/utils/utils';
import {MatDialog} from '@angular/material/dialog';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatOption } from '@angular/material/select';
import { NgStyle, NgClass } from '@angular/common';
import { LoadingIconComponent } from '../../../../../../../shared/components/loading-icon/loading-icon.component';

@Component({
    selector: 'app-whats-app-settings',
    templateUrl: './whats-app-settings.component.html',
    styleUrls: ['./whats-app-settings.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, MatInput, MatAutocompleteTrigger, ActiveFormDirective, MatAutocomplete, MatOption, NgStyle, LoadingIconComponent, MatExpansionPanel, MatExpansionPanelHeader, NgClass]
})
export class WhatsAppSettingsComponent implements OnInit, OnChanges {

    readonly EVENT_LIMITS = {
        overflow: 1,
        min: 1
    };

    readonly CUSTOM_DATA_LIMITS = {
        overflow: 1
    };

    @ViewChild('slider') slider: ElementRef;
    @ViewChild('confirmationDialog') dialogTemplate: TemplateRef<any>;

    @Input() step: Step | string;
    @Input() isDisabled: boolean;
    @Output() update: EventEmitter<{ [key: string]: any }> = new EventEmitter();
    @Output() close = new EventEmitter();

    public isOpen = false;
    public conversionForm: UntypedFormArray;
    public waBusinessAccounts: WaBusinessAccounts[] = undefined;
    public waBusinessAccountsFiltered: WaBusinessAccounts[] = [];

    constructor(private sendTemplateService: SendTemplateService,
                private dialog: MatDialog) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.step) {
            const metadata = this.step['metadata'] || {};
            this.conversionForm = WaSettings.toForm(metadata, this.isDisabled);
        }
    }

    ngOnInit(): void {
        this.sendTemplateService.get_accounts().pipe(
            tap(data => this.waBusinessAccounts = data),
            tap(data => this.waBusinessAccountsFiltered = data.slice())
        ).subscribe();
    }


    public closeOverlay(): void {
        this.isOpen = false;
        this.close.emit();
    }

    public saveSettings(): void {
        if (!this.isDisabled) {
            return;
        }

        this.conversionForm.markAllAsTouched();

        if (!this.conversionForm.valid) {
            swalMini({title: 'Please fill all required fields', type: 'error'});
            return;
        }

        this.isOpen = false;
        this.update.emit(WaSettings.setConversion(this.conversionForm.getRawValue()));
    }

    public wabaFilter(element: HTMLInputElement) {
        const filterValue = element.value;
        if (isEmpty(this.waBusinessAccounts)) {
            this.waBusinessAccountsFiltered = [];
            return;
        }
        this.waBusinessAccountsFiltered = this.waBusinessAccounts?.filter(option => option.wabaName.includes(filterValue));
    }

    public waBusinessAccountsDisplay(id: string): string {
        if (this.waBusinessAccounts && id) {
            return this.findWaBusinessAccounts(id).wabaName;
        }

        return '';
    }

    private findWaBusinessAccounts(id: string): WaBusinessAccounts {
        return this.waBusinessAccounts?.find(x => x.wabaId === id);
    }

    public onDeleteEvent(index: number, events: UntypedFormArray) {
        if (!this.isDisabled) {
            return;
        }
        if (events.length === this.EVENT_LIMITS.min) {
            swalMini({title: 'At least event is required', type: 'error'});
            return;
        }
        events.removeAt(index);
    }

    public onAddNewEvent(events: UntypedFormArray) {
        if (!this.isDisabled) {
            return;
        }
        const waConversionsEvent: WaConversionsEvent = {
            eventName: '',
            customData: {}
        };
        events.push(WaSettings.eventFormTemplate(waConversionsEvent, this.isDisabled));
    }

    public onDeleteCustomData(index: number, customData: UntypedFormArray) {
        if (!this.isDisabled) {
            return;
        }
        customData.removeAt(index);
    }

    public onAddCustomData(customData: UntypedFormArray) {
        if (!this.isDisabled) {
            return;
        }

        customData.push(WaSettings.customDataFormTemplate('', '', this.isDisabled));
    }

    public onReset() {
        this.dialog.open(this.dialogTemplate, {
            width: '530px',
            height: '160px',
            disableClose: true,
        });
    }

    public onConfirmReset() {
        this.dialog.closeAll();
        this.conversionForm = WaSettings.toForm({}, this.isDisabled);
        this.isOpen = false;
        this.update.emit(undefined);
    }

    public onResetCancel() {
        this.dialog.closeAll();
    }
}
